import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/hero/Hero';
import { TrustStrip } from './components/sections/TrustStrip';
import { Problems } from './components/sections/Problems';
import { Solution } from './components/sections/Solution';
import { CoreContent } from './components/sections/CoreContent';
import { InsidePreview } from './components/preview/InsidePreview';
import { Bonuses } from './components/bonuses/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalComparison } from './components/sections/FinalComparison';
import { Footer } from './components/layout/Footer';
import { StickyBar } from './components/layout/StickyBar';
const PAGE_TITLE = 'Handball Class Ready — 12 Ready-to-Teach School Handball Lessons for Ages 8–11';
const PAGE_DESCRIPTION = 'A 40-page visual PDF guide with twelve complete 40-minute team handball lessons for ages 8–11, plus 5 teaching resources. $27 USD one-time, with a 10-day money-back guarantee.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="33n6wl09m5n39">
      <div className="min-h-screen w-full overflow-x-clip bg-ink font-sans text-base text-white" data-id="element-1" data-mp="38m1g64fenfof">
        <a href="#main" className="sr-only bg-gold px-5 py-3 font-bold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70]" data-id="element-2" data-mp="3dkl3o99ncziw">
          Skip to content
        </a>
        <main id="main" data-id="element-3" data-mp="su42lc18kscl">
          <Hero data-id="element-4" data-mp="stc7s3fgqynd" />
          <TrustStrip data-id="element-5" data-mp="sssrer5goibg" />
          <Problems data-id="element-6" data-mp="swgi7ijiuqmh" />
          <Solution data-id="element-7" data-mp="35ypel6klo1z" />
          <CoreContent data-id="element-8" data-mp="35gm54lhq9kk" />
          <InsidePreview data-id="element-9" data-mp="34napqbl6vw3" />
          <Bonuses data-id="element-10" data-mp="38b2ol1dva8p" />
          <Offer data-id="element-11" data-mp="3udawu8hnin4p" />
          <Guarantee data-id="element-12" data-mp="3ubrfsfo6881v" />
          <Faq data-id="element-13" data-mp="3uc9jfxd5xojt" />
          <FinalComparison data-id="element-14" data-mp="3uevsk1fpcc45" />
        </main>
        <Footer data-id="element-15" data-mp="d57fh2ybeij2" />
        <StickyBar data-id="element-16" data-mp="d3mmhhrnf7nb" />
      </div>
    </MotionConfig>;
}